
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "../ServerSideStates";
import { deltaToHTML } from "helpers/DeltaToHtml";
import { isValidJSON } from "helpers/IsValidJson";
import PageTitle from "apps/Common/PageTitle";

const Descriptions = () => {
 
  const [searchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const advertDetails = useGetAdvertDetails(advertId);
  const data = advertDetails?.data?.data;

  return (
    <>
      <div className="!grid gap-2">
        <div>
          <PageTitle title="Açıklama" />
        </div>
        <div>
          {data?.desc && isValidJSON(data.desc) && (
            <p
              dangerouslySetInnerHTML={{
                __html: deltaToHTML(JSON.parse(data.desc)),
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Descriptions;
